import { deviceid } from "@/uitls/uitls";
import Storage from "@/uitls/Storage";
import axios from "axios";
import Platform from "@/config/platform";
import { base64Encode } from "@/store/playerDomain"

export const createImNetWork = () => {
  const ImNetWork = class {
    private address?: any;
    //是否可以强制刷新
    private isReload: boolean;
    //第几次检查域名了
    private netWorkIndex: number;

    private LOGIN_METHODS = ["IMUser.guestLogin", "IMUser.verifyLogin", "IMUser.passwdLogin", "IMUser.fastLogin"];

    post(url: string, data: any = {}, address?: string) {
      return new Promise((resolve, reject) => {
        this.request(url, data, (e: any, result: any) => {
          if (result) {
            resolve(result);
          } else {
            reject(e);
          }
        }, address);
      });
    }
    // 上传文件
    upload(url: string, data: any = {}, address?: string) {
      return new Promise((resolve, reject) => {
        this.requestupload(url, data, (e: any, result: any) => {
          if (result) {
            resolve(result);
          } else {
            reject({ ret: 1 });
          }
        },
          address
        );
      });
    }
    // 获取上传文件的url
    uploadurl(url: string, data: any = {}, address?: string) {
      return new Promise((resolve, reject) => {
        this.requestuploadurl(url, data, (e: any, result: any) => {
          if (result) {
            resolve(result);
          } else {
            reject(e);
          }
        },
          address
        );
      });
    }
    getAddress = () => {
      this.netWorkIndex = 0;
      this.isReload = false;
      //第一次进来，获取历史的baseurl
      let _url = Storage.get("DOMAIN_LIST_IM");

      const IMApi = process.env.VUE_APP_IMApi as string;

      const IMApiList: Array<string> = IMApi.split(",");
      if (_url == null || _url == "") {
        _url = IMApiList[Math.floor(Math.random() * IMApiList.length)];
      }
      if (_url[_url.length - 1] != "/") {
        _url = _url + "/";
      }
      this.address = _url;
      this.checkHttp(IMApiList, true);
      this.checkNetWork(_url)
      return _url;
    };

    //单独对这个url检测一下，如果访问不通的，弹出刷新警告
    async checkNetWork(url) {
      try {
        const res: any = await this.post("IMTools.testNet", {}, url);
      } catch (error) {
        console.log("这域名不通");
        this.isReload = true;
      }
    }

    //检查域名是否可用
    async checkHttp(IMApiList: Array<string>, doAdmin = false) {
      for (let i = 0; i < IMApiList.length; i++) {
        //循环发送网络请求
        let _url = IMApiList[i];
        if (_url[_url.length - 1] != "/") {
          _url = _url + "/";
        }
        try {
          const res: any = await this.post("IMTools.testNet", {}, _url);
          if (res.ret == 0) {
            // if (!doAdmin) {
            //   console.log('成功拿到im地址');
            // }
            this.address = _url;
            Storage.set("DOMAIN_LIST_IM", _url);
            if (this.isReload) {
              console.log("可以强制刷新");
              location.reload()
            }
            return;
          }
        } catch (error) {
          //要不要去请求桶地址
          // console.log("im网络请求不通");
          this.netWorkIndex++;
          if (doAdmin && this.netWorkIndex == IMApiList.length) {
            console.log("去请求im桶");
            this.toMains();
          }
        }
      }


    }

    //去请求桶拿地址
    toMains() {
      // VITE_TXDOMAINCONFIG
      const txUri = process.env.VUE_APP_TXDOMAINCONFIG as string;
      const aliUri = process.env.VUE_APP_ALDOMAINCONFIG as string;
      const appID = process.env.VUE_APP_APPID as string;

      // 请求腾讯桶
      axios.get(txUri).then((response) => {
        if (response.status == 200) {
          const d: Array<string> = response.data[appID];
          this.checkHttp(d, false);
        }
      });
      // 请求阿里桶
      axios.get(aliUri).then((response) => {
        if (response.status == 200) {
          const d: Array<string> = response.data[appID];
          this.checkHttp(d, false);
        }
      });
    }

    request(method: string, data: any, callback: any, address2?: string) {
      const formData = new FormData();
      // console.log('IMApp.hostApi',IMApp.hostApi);
      let app_channel = process.env.VUE_APP_CHANNEL as string;
      const th = process.env.VUE_APP_Language as string;
      
      let client_channel = Platform.channel != 0 ? Platform.channel : app_channel;
      const standalone = Platform.standalone;
      const isLogin = this.LOGIN_METHODS.indexOf(method) >= 0;
      const datas = {
        method: method,
        siteid: (standalone && !isLogin ? "1" : "3"),
        channel: client_channel,
        param: data,
        version: process.env.VUE_APP_VERSION as string,
        deviceid: deviceid("deviceid"),
        uid: Storage.get("uid"),
        invitefid: Platform.from_invite_code || undefined,
        lang: th
      };

      console.log("imNet请求的参数=", datas);

      const d = JSON.stringify(datas);
      formData.append("win_param", d);


      if (!this.address) {
        this.address = this.getAddress();
      }
      let url = '';
      if (address2) {
        url = address2 + "api/flashapi.php";
      } else {
        url = this.address + "api/flashapi.php";
      }
      fetch(url, {
        method: "POST",
        body: formData,
      })
        .then((res) => {
          return res.text();
        })
        .then((json) => {
          console.log(`${method}接口返回的数据：${json}`);
          try {
            const data = JSON.parse(json);
            callback && callback(null, data);
          } catch (e) {
            callback(e, null);
          }
        })
        .catch((e) => {
          callback && callback(e, null);
        });
    }

    // 上传文件
    requestupload(method: string, data: any, callback: any, address2?: string) {
      let url = "";
      if (!this.address) {
        this.address = this.getAddress();
      }
      if (address2) {
        url = address2 + method;
      } else {
        url = this.address + method;
      }
      fetch(url, {
        method: "POST",
        body: data,
      })
        .then((res) => {
          return res.text();
        })
        .then((json) => {
          try {
            const data = JSON.parse(json);
            callback && callback(null, data);
          } catch (e) {
            callback(e, null);
          }
        })
        .catch((e) => {
          callback && callback(e, null);
        });
    }
    requestuploadurl(
      method: string,
      data: any,
      callback: any,
      address2?: string
    ) {
      if (!this.address) {
        this.address = this.getAddress();
      }
      let url = "";
      if (address2) {
        url = address2 + method;
      } else {
        url = this.address + method;
      }
      try {
        callback && callback(null, url);
      } catch (e) {
        callback(e, null);
      }
    }
  };
  return new ImNetWork();
};

export const ImNetWork = createImNetWork();

export default ImNetWork;
